import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CreateAccountForm } from "@/components/shell/CreateAccountForm";
import {
  rememberAccountId,
  useOptionalAccountWorkspace,
  type WorkspaceAccount,
} from "@/lib/account-workspace";
import { useNavigate } from "react-router";

type CreateAccountDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/** For users who already have accounts and want to add another (AccountSwitcher). */
export function CreateAccountDialog({ open, onOpenChange }: CreateAccountDialogProps) {
  const navigate = useNavigate();
  const workspace = useOptionalAccountWorkspace();

  async function handleSuccess(account: WorkspaceAccount) {
    rememberAccountId(account.id);
    await workspace?.refreshAccounts();
    onOpenChange(false);
    navigate(`/accounts/${account.id}`);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>创建账户</DialogTitle>
          <DialogDescription>创建一个新的商家账户，你将成为所有者。</DialogDescription>
        </DialogHeader>
        <CreateAccountForm
          active={open}
          onCancel={() => onOpenChange(false)}
          onSuccess={handleSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
